import { Radio, RadioGroup, Stack } from '@chakra-ui/react';

import { useFilterState } from '../../hooks/useFilterState';
import { DataTableFilterOption, DataTableFilterType } from '../../utils/typings';
import { FilterPopoverContent } from '../FilterPopoverButton';

type Props<T extends DataTableFilterType> = {
  value: string;
  options: DataTableFilterOption<T>[];
  onChange: (value: string) => void;
  onSubmit: () => void;
};

export const RadioFilterPopoverContent = <T extends DataTableFilterType>({
  value,
  options,
  onChange,
  onSubmit,
}: Props<T>) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit,
  });

  const handleChange = (value: string) => {
    onChange(value);
    state.onChange(value);
  };

  const renderOption = (option: DataTableFilterOption<T>) => {
    return (
      // Using the onChange here rather than on the group should let us handle nulls properly. Hopefully.
      // also an unfortunate type cast
      <Radio
        key={option?.label}
        isChecked={state.value === option?.value}
        onChange={() => handleChange(option?.value as string)}
      >
        {option?.label}
      </Radio>
    );
  };

  return (
    <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
      <RadioGroup>
        <Stack>{options?.map(renderOption)}</Stack>
      </RadioGroup>
    </FilterPopoverContent>
  );
};
